import { Input, InputGroup, InputRightElement, Icon, useColorModeValue } from "@chakra-ui/react"
import { MdDateRange } from "react-icons/md"

const DatePicker = ({ isoDate, onDateChange }) => {
    const iconColor = useColorModeValue("brand.red", "brand.red");

    const handleDateChange = (event) => {
        const inputValue = event.target.value;
        let newDate;

        if (inputValue) {
            newDate = new Date(inputValue);
        } else {
            newDate = new Date();
        }

        // Adjust for the time zone offset
        const offsetMinutes = newDate.getTimezoneOffset();
        newDate = new Date(newDate.getTime() + offsetMinutes * 60 * 1000);

        const year = newDate.getFullYear();
        const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
        const day = newDate.getDate().toString().padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        onDateChange(formattedDate);
    }

    const handleClick = (e) => {
        if (e.target.showPicker) {
            e.target.showPicker();
        }
    };

    return (
        <InputGroup width="170px">
            <Input
                placeholder="Select a date"
                bg="card.bg"
                color="hero.text"
                borderColor="card.border"
                borderWidth="1px"
                borderRadius="none"
                size="md"
                type="date"
                fontWeight="900"
                fontSize="sm"
                value={isoDate}
                onChange={handleDateChange}
                onClick={handleClick}
                cursor="pointer"
                _hover={{ bg: "pbp.item.hover" }}
                _focus={{ borderColor: "brand.red", boxShadow: "none" }}
                sx={{
                    "&::-webkit-calendar-picker-indicator": {
                        filter: useColorModeValue("none", "invert(1)"),
                        cursor: "pointer",
                        position: "absolute",
                        right: "8px",
                        opacity: 0, // We hide the native one because we use the InputRightElement icon
                        width: "100%"
                    }
                }}
            />
            <InputRightElement pointerEvents="none" mr={1}>
                <Icon as={MdDateRange} color={iconColor} fontSize="18px" />
            </InputRightElement>
        </InputGroup>
    )
}
export default DatePicker